// Daily letter generation quota — stored in localStorage only (RGPD-safe).
const KEY = "aia_letter_quota";
export const DAILY_LIMIT = 4;

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { date: todayKey(), count: 0 };
    const parsed = JSON.parse(raw);
    if (parsed.date !== todayKey()) return { date: todayKey(), count: 0 };
    return parsed;
  } catch {
    return { date: todayKey(), count: 0 };
  }
}

function write(state) {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function getLetterUsage() {
  return read();
}

export function getLetterRemaining() {
  const { count } = read();
  return Math.max(0, DAILY_LIMIT - count);
}

export function canGenerateLetter() {
  return getLetterRemaining() > 0;
}

export function consumeLetter() {
  const s = read();
  s.count += 1;
  write(s);
  return s.count;
}
